export function useBaseUrl() {
  return window.location.origin;
}
